import { DateTime } from 'luxon';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useFranchiseeContext } from '../../context/Franchisee';
import { useLeadContext } from '../../context/Lead';
import { getPackageById } from '../../data/cleaningPackages';
interface BookingSummaryProps {
  // add Booking Summary props here
  className?: string;
  errorToast?: boolean;
}

const BookingSummary: React.FC<BookingSummaryProps> = ({
  className,
  errorToast,
}: BookingSummaryProps) => {
  const { lead } = useLeadContext();
  const { bedrooms, bathrooms, people, pets, squareFootage } = lead;

  const { timezone: franchiseeTimeZone } = useFranchiseeContext().franchisee;

  const [cleaningDate, setCleaningDate] = useState<DateTime>(null);
  const morningTimes = ['480', '510', '540', '570', '600', '630'];
  const midDayTimes = ['660', '690', '720', '750', '780', '810'];
  const afternoonTimes = ['840', '870', '900', '930', '960', '990', '1020'];
  const options: Intl.DateTimeFormatOptions = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };

  useEffect(() => {
    const { dateTime } = lead;
    // console.log({ dateTime });
    if (dateTime !== null) {
      const targetDate = DateTime.fromISO(dateTime, {
        zone: franchiseeTimeZone,
      });
      setCleaningDate(targetDate);
    }
  }, [lead]);

  const displayTime = (): string => {
    // console.log(new Date(moment(user.dayID).format('YYYY/MM/DD')));
    if (cleaningDate === null) return '';
    if (cleaningDate.hour >= 8 && cleaningDate.hour < 11)
      return 'Morning (8am - 11am)';
    if (cleaningDate.hour >= 11 && cleaningDate.hour < 14)
      return 'Midday (11am - 2pm)';
    if (cleaningDate.hour >= 14 && cleaningDate.hour <= 16)
      return 'Afternoon (2pm-5pm)';
    return '';
  };

  useEffect(() => {
    // console.log(errorToast)
    setCleaningDate(null);
  }, [errorToast]);

  const packageId =
    typeof lead.package === 'string'
      ? parseInt(lead.package, 10)
      : lead.package;

  return (
    <div className={`book__summary`}>
      <hr />
      <div className='summary-with-order mt-1 mb-1'>
        <h1 className='h3'>BOOKING SUMMARY</h1>
        {/* <h1 className='h3'>Order #</h1> */}
      </div>
      <hr />
      <Row>
        <Col xs={12} md={6} className='order-1 order-md-0'>
          <p className='lead font-weight-bold'>
            <span data-summary='package'>
              {getPackageById(packageId).name}
            </span>
          </p>
          <p className=''>
            <span data-summary='squareFootage'>{squareFootage} sq. ft.</span>
            <br />
            <span data-summary='bedrooms'>{bedrooms} bedrooms</span>
            <br />
            <span data-summary='bathrooms'>{bathrooms} bathrooms</span>
            <br />
            <span data-summary='people'>{people} people</span>
            <br />
            <span data-summary='pets'>{pets} pets</span>
          </p>
        </Col>
        <Col xs={12} md={6} className='order-0 order-md-1'>
          {/* Add vonigo here */}
          <p className='lead font-weight-bold'>
            {cleaningDate !== null &&
              cleaningDate.toFormat('DDDD') !== 'Invalid DateTime' && (
                <>
                  <span data-summary='appointmentDate'>
                    {cleaningDate.toFormat('DDDD')}
                  </span>

                  <br />
                  <small className='font-weight-bold'>
                    <span
                      data-summary='appointmentTime font-weight-bold'
                      className='appointmentTime'
                    >
                      {displayTime()}
                    </span>
                  </small>
                </>
              )}
          </p>
        </Col>
      </Row>
    </div>
  );
};

BookingSummary.defaultProps = {
  className: '',
};

export default BookingSummary;
